@if (!isDismissed()) {
<div class="hexagons-wrap">
  <rt-impact-tracker-hexagons />
</div>

<div class="content">
  <div class="title-wrap">
    <div class="icon-wrap">
      <ng-content select="[icon]" />
    </div>
    <div class="text-container">
      <div class="subheading">{{subheading() }}</div>
      <div class="heading" [innerHTML]="headingHTML()"></div>
    </div>
  </div>
  <div class="cta-container">
    <ng-content select="[cta]" />
    <rt-icon-button (click)="dismiss()" variant="plain" iconName="close" />
  </div>
</div>
}
